import type { Podcast } from '@edwin-group/people-graphql';

export default function isPodcastDone(podcast: Podcast): { progress: number; isDone: boolean } {
  const listening = podcast?.listenings?.[0];
  if (!listening?.duration || listening.duration <= 0) {
    return { progress: 0, isDone: false };
  }

  const duration = Number(listening.duration);
  const listeningTime = Number(listening.listeningTime);
  const progress = Math.min(100, Math.ceil((listeningTime / duration) * 100));
  const isDone = progress >= 90;

  return { progress, isDone };
}
